import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';

export interface ChartTooltipProps {
  formattedDate: string;
  temperature: number;
  temperatureInfo: {
    color: string;
    status: string;
  } | null;
  deviceName: string;
  rackId: string;
  theme: Theme;
}

export const ChartTooltip: React.FC<ChartTooltipProps> = ({
  formattedDate,
  temperature,
  temperatureInfo,
  deviceName,
  rackId,
}) => {
  return (
    <Box>
      <Typography variant='body2'>{formattedDate}</Typography>

      <Box>
        <Typography component='span'>Temperature:</Typography>
        <Typography> {temperature.toFixed(1)}°C</Typography>
      </Box>

      <Box>
        <Typography component='span'>Status:</Typography>
        <Typography component='strong'>
          {' '}
          {temperatureInfo?.status || 'Normal'}
        </Typography>
      </Box>

      <Typography variant='caption'>
        {deviceName} - {rackId}
      </Typography>
    </Box>
  );
};

ChartTooltip.displayName = 'ChartTooltip';
